import { IResponse } from "../types";
import {
  IAuthResponse,
  ILoginCodeResponse,
  IRegisterRequest,
  IUserAuthResponse,
  TLoginGoogleRequest,
  TLoginRequest,
  TLoginWithCodeRequest,
  TSendCodeRequest,
  TSendCodeWithoutLoginRequest,
} from "../types/auth.types";
import { api } from "./api";

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<IUserAuthResponse, TLoginRequest>({
      query: ({ email, password }) => ({
        url: `/user/login`,
        method: "POST",
        body: {
          email: email,
          password: password,
          roleId: 0,
        },
      }),
    }),
    loginWithCode: build.mutation<ILoginCodeResponse, TLoginWithCodeRequest>({
      query: ({ phone, usersId }) => ({
        url: `user/code`,
        method: "POST",
        body: JSON.stringify({
          phone,
          code: "0",
          roleId: "0",
          usersId,
        }),
      }),
    }),
    loginGoogle: build.mutation<IUserAuthResponse, TLoginGoogleRequest>({
      query: (body) => ({
        url: `user/login/google`,
        method: "POST",
        body,
      }),
    }),
    authWithCode: build.mutation<IUserAuthResponse, TSendCodeRequest>({
      query: ({ phone, code, email, password, usersId }) => ({
        url: `user/authWithCode`,
        method: "POST",
        body: JSON.stringify({
          phone: phone,
          usersId,
          code,
          roleId: "0",
          email,
          password,
        }),
      }),
    }),
    sendCodeWithoutLogin: build.mutation<
      ILoginCodeResponse,
      TSendCodeWithoutLoginRequest
    >({
      query: ({ phone }) => ({
        url: `user/codeWithoutLogin`,
        method: "POST",
        body: JSON.stringify({ phone, code: "0", roleId: "0" }),
      }),
    }),
    authWithoutLogin: build.mutation<IUserAuthResponse, TSendCodeRequest>({
      query: (body) => ({
        url: `user/authWithoutLogin`,
        method: "POST",
        body,
      }),
    }),
    logout: build.mutation<IResponse, string>({
      query: (refreshToken) => ({
        url: `/logout`,
        method: "POST",
        body: {
          token: refreshToken,
        },
      }),
    }),
    restorePassword: build.mutation<IResponse, string>({
      query: (emailOrPhone) => ({
        url: `/restore_password`,
        method: "POST",
        body: {
          emailOrPhone,
        },
      }),
    }),
    impersonateCompany: build.mutation<
      { accessToken: string; success: boolean },
      { companyId: number }
    >({
      query: ({ companyId }) => ({
        url: `user/impersonate/${companyId}`,
        method: "POST",
      }),
    }),
    getTokenForTherapist: build.mutation<
      { code: string; success: boolean },
      void
    >({
      query: () => ({
        url: `user/switchRoleUserToken`,
        method: "POST",
      }),
    }),
    redeemSwitchCode: build.mutation<
      IUserAuthResponse,
      { code: string }
    >({
      query: ({ code }) => ({
        url: `user/redeemSwitchCode`,
        method: "POST",
        body: { code },
      }),
    }),
    verifySsoToken: build.mutation<IAuthResponse, string>({
      query: (token) => ({
        url: `user/validate/sso`,
        method: "POST",
        body: JSON.stringify(token),
      }),
    }),
    SwitchCompanyUser: build.mutation<
      { accessToken: string; success: boolean },
      { guid: string; companyId: number }
    >({
      query: ({ guid, companyId }) => ({
        url: `user/SwitchCompanyUserToken/${companyId}`,
        method: "POST",
        body: JSON.stringify(guid),
      }),
    }),
  }),
});

export const {
  useLoginGoogleMutation,
  useLoginWithCodeMutation,
  useSendCodeWithoutLoginMutation,
  useAuthWithoutLoginMutation,
  useImpersonateCompanyMutation,
  useGetTokenForTherapistMutation,
  useRedeemSwitchCodeMutation,
  useVerifySsoTokenMutation,
  useSwitchCompanyUserMutation,
} = authApi;
